import type { StorefrontOrder } from "@bytebite/schemas";

export const KITCHEN_STEPS = ["preparing", "ready", "completed"] as const;
export type KitchenStep = (typeof KITCHEN_STEPS)[number];

export function nextKitchenStatus(order: StorefrontOrder): KitchenStep | null {
  if (order.orderStatus === "accepted") return "preparing";
  if (order.orderStatus === "preparing") return "ready";
  if (order.orderStatus === "ready") return "completed";
  return null;
}

export function kitchenActionLabel(step: KitchenStep): string {
  if (step === "preparing") return "Preparing";
  if (step === "ready") return "Ready";
  return "Completed";
}

export function kitchenWritePath(restaurantId: string, orderId: string, step: KitchenStep): string {
  const action = step === "completed" ? "complete" : step;
  return `/dashboard/restaurants/${restaurantId}/orders/${orderId}/${action}`;
}
